const blockquote = {
	group: "block",
	content: "block+",
};

export default blockquote;
